import React from 'react';
import { useMediaQuery } from './hooks/useMediaQuery';
import Banner from './components/Banner';
import Header from './components/Header';
import VideoSection from './components/VideoSection';
import GameCarousel from './components/GameCarousel';
import WishlistSection from './components/WishlistSection';
import DemoSection from './components/DemoSection';
import SocialSection from './components/SocialSection';
import Footer from './components/Footer';
import DesktopLayout from './components/DesktopLayout';
import Policy from './components/Policy';
import { PolicyProvider } from './context/PolicyContext';
import './App.css';

function App() {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <PolicyProvider>
    <div className={`App ${isMobile ? 'App--mobile' : 'App--desktop'}`}>
      {/* <Banner /> */}
      {isMobile ? (
        <>
          <div className="mobile-page-1">
            <Header isMobile={isMobile} />
            <VideoSection isMobile={isMobile} />
            <WishlistSection isMobile={isMobile} />
          </div>
          <div className="mobile-page-2">
            <DemoSection isMobile={isMobile} />
            <GameCarousel isMobile={isMobile} />
            <SocialSection isMobile={isMobile} />
            <Footer isMobile={isMobile} />
          </div>
        </>
      ) : (
        <DesktopLayout />
      )}
      <Policy />
    </div>
    </PolicyProvider>
  );
}

export default App;
